/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
export default {
    __name: 'select-popup',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        columns: {
            type: Array,
            default: function() {
                return [];
            }
        },
        selection: {
            type: [
                String,
                Number
            ],
            default: ''
        }
    },
    emits: [
        'confirm',
        'close-popup'
    ],
    setup: function(__props, param) {
        var emit = param.emit;
        var props = __props;
        var close = function() {
            emit('close-popup', props.value);
        };
        var handleClick = function(item, index) {
            console.log(item, index, 'selected');
            emit('confirm', item);
            close();
        };
        watch(function() {
            return props.value;
        }, function(val) {
            if (val) {
                console.log(val, 'val');
            }
            if (val) {
                nextTick(function() {
                    console.log(val, 'val nextTick');
                });
            }
        });
        return {
            __sfc: true,
            props: props,
            emit: emit,
            close: close,
            handleClick: handleClick
        };
    }
};
